import { Outlet, Link } from "react-router-dom";
import Title from "../components/ui/Title";
import '../styles/pages/media.scss'

const Gallery = () => {
    return (
        <div className="page-container">
            <Title text="Gallery" size="full"/>
            <nav className="media-nav">
                <Link to='/gallery/trailers'>
                    <h1 className="media-link">
                        Trailers
                    </h1>
                </Link>
                <Link to='/gallery/wallpapers'>
                    <h1 className="media-link">
                        Wallpapers &amp; Avatars
                    </h1>
                </Link>
            </nav>
            <Outlet/>
        </div>
    )
}

export default Gallery;